module.exports = __webpack_public_path__ + "media/images/tailwind/ham-menu-c6af6ca8ae4e3c596628b8b5c5abbfae.png";